module.exports = __webpack_public_path__ + "media/amp_version/instagram-f25bae9d.svg";